<template>
    <div>

        <div class="card dashcard mb-0">

            <div class="card-body">

                <div class="form-row">
                    <div class="col col-12 col-md-3">
                        <az-input
                            buttonText="fas fa-sync-alt fa-fw"
                            :buttonIcon="true"
                            buttonColor="outline-primary"
                            icon="fas fa-sync-alt fa-fw"
                            type="date"
                            v-model="referencia"
                            @clickButton="load()" />
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input
                            icon="fas fa-layer-group fa-fw"
                            placeholder="Todos..."
                            type="select"
                            service="estoque_grupo_locals.index"
                            optionsData="id_estoque_grupo_local"
                            optionsMode="aql"
                            :edicao="!id_estoque_local"
                            v-model="id_estoque_grupo_local" />
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input
                            icon="far fa-building fa-fw"
                            type="select"
                            placeholder="Todas"
                            :optionsList="$util.unidades_com_tags(false, true)"
                            optionsData="id_unidade_operacao"
                            :edicao="!id_estoque_grupo_local"
                            v-model="id_unidade_operacao" />
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input
                            icon="fas fa-warehouse fa-fw"
                            placeholder="Todos..."
                            type="select"
                            service="estoque_locals.index"
                            optionsData="id_estoque_local"
                            optionsMode="aql"
                            optionsName="estoque_locals.index.sup"
                            :optionsParm="{ sup: 1 }"
                            :edicao="!id_estoque_grupo_local"
                            v-model="id_estoque_local" />
                    </div>

                </div>

                <div class="form-row mt-2">
                    <div class="col col-12 col-md-3">
                        <az-input
                            icon="fab fa-google fa-fw"
                            placeholder="Todos os Grupos..."
                            type="select"
                            service="estoque_grupos.index"
                            optionsData="id_estoque_grupo"
                            optionsMode="aql"
                            v-model="id_estoque_grupo" />
                    </div>
                    <div class="col col-12 col-md-6">
                        <az-input
                            placeholder="Todos o itens..."
                            icon="fa-solid fa-box fa-fw"
                            type="autocomplete" 
                            optionsMode="aql"
                            service="estoque_items.index"
                            :optionsSync="false"
                            optionsData="id_estoque_item"
                            v-model="id_estoque_item" />
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input
                            icon="fa-solid fa-c fa-fw"
                            type="select"
                            placeholder="Todos..."
                            :optionsList="[
                                { id: 'S', search: 'Consignados' },
                                { id: 'N', search: 'Não Consignados' }
                            ]"
                            optionsData="id"
                            v-model="busca_consig" />
                    </div>
                </div>

                <div class="form-row mt-2">
                    <div class="col col-12 col-md-6">
                        <az-input
                            icon="fa fa-search fa-fw"
                            v-model="search">
                            <template v-slot:buttonposb>
                                <print-export
                                    :printid="print_id"
                                    :left="true"
                                    @beforeprint="definir_print_id()"
                                    :dados="dados_saldos" />
                            </template>
                        </az-input>
                    </div>

                    <div class="col col-12 col-md-2">
                        <az-input   
                            type="checkbox-group"
                            label="Saldo por Lotes"
                            v-model="saldo_por_lote" />
                    </div>

                    <div class="col col-12 col-md-1 d-flex flex-column">
                        <div class="btn-group mb-1" role="group" aria-label="Basic example">
                            <button type="button" class="btn" :class="curva == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" @click="curva == 'A' ? curva = '' : curva = 'A'">A</button>
                            <button type="button" class="btn" :class="curva == 'B' ? 'btn-secondary' : 'btn-outline-secondary'" @click="curva == 'B' ? curva = '' : curva = 'B'">B</button>
                            <button type="button" class="btn" :class="curva == 'C' ? 'btn-secondary' : 'btn-outline-secondary'" @click="curva == 'C' ? curva = '' : curva = 'C'">C</button>
                        </div>
                    </div>

                    <div class="col col-12 col-md-3">
                        <az-input
                            type="button-group"
                            :optionsList="[{id:'S',search:'Com Saldo'},{id:'P',search:'PR'},{id:'T',search:'Todos'}]"
                            v-model="viewMode" />
                    </div>
                </div>

            </div>

        </div>

        <div class="progress mt-1 mb-1">
            <div class="indeterminate" v-if="$store.state.loading && lista.length"></div>
            <div class="determinate" v-else></div>
        </div>

        <az-empty-state
            :msg="firstLoad ? 'Nenhum item encontrado.' : 'Buscar Saldos...'"
            :icon="firstLoad ? 'fas fa-box-open' : 'fas fa-sync-alt'"
            v-if="!lista.length" />

        <template v-else>

            <div class="mb-2 d-flex justify-content-between">
                <div>
                    <div class="btn-group btn-group-sm" role="group" aria-label="Basic example">
                        <button type="button" class="btn" :class="tipoParm == 'P' ? 'btn-secondary' : 'btn-outline-secondary'" @click="tipoParm = 'P'">Parâmetros</button>
                        <button type="button" class="btn" :class="tipoParm == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" @click="tipoParm = 'T'">Tempos</button>
                        <button type="button" class="btn" :class="tipoParm == 'C' ? 'btn-secondary' : 'btn-outline-secondary'" @click="tipoParm = 'C'">Preço Médio</button>
                    </div>

                    <div v-if="tipoParm == 'T'" class="mt-2">
                        <button type="button" class="btn btn-outline-primary btn-sm" @click="definir_tempo('IC')">
                            Definir IC
                        </button>

                        <button type="button" class="btn btn-outline-primary btn-sm ml-1" @click="definir_tempo('TMR')">
                            Definir TMR
                        </button>
                    </div>
                </div>
                <div class="text-right">
                    <template v-if="lista_tags && lista_tags.length <= 15">
                        <a href="#" @click.prevent="search == '&quot;' + tag + '&quot;' ? search = '' : search = '&quot;' + tag + '&quot;'"
                                v-for="(tag, itx) in lista_tags" :key="itx">
                            <span class="badge badge-success mr-1" >
                                {{ tag }}
                            </span>
                        </a>
                    </template>

                    <a href="#" @click.prevent="detalhado = !detalhado" class="card-link ml-2">
                        <i class="fa-solid fa-minimize fa-fw" v-if="detalhado"></i>
                        <i class="fa-solid fa-maximize fa-fw" v-else></i>
                    </a>
                </div>
            </div>

            <ul class="nav nav-tabs" id="myTab" role="tablist">
                <li class="nav-item" role="presentation">
                    <a class="nav-link active" id="saldo-items-tab" data-toggle="tab" href="#saldo-items" role="tab" aria-controls="saldo-items" aria-selected="true">Itens</a>
                </li>
                <li class="nav-item" role="presentation" v-if="!buscado_por_lote">
                    <a class="nav-link" id="saldo-grupos-tab" data-toggle="tab" href="#saldo-grupos" role="tab" aria-controls="saldo-grupos" aria-selected="false">Grupos</a>
                </li>
            </ul>

            <div class="tab-content" id="myTabContent">
                <div class="tab-pane fade show active" id="saldo-items" role="tabpanel" aria-labelledby="saldo-items-tab">

                    <!-- ITENS -->

                    <div class="table-responsive-md" id="lista-saldos">

                        <cabecalho-generico titulo="Saldos">
                            <div v-if="dados_busca">
                                <div v-if="nome_grupo_local">{{ nome_grupo_local }}</div>
                                <div v-else-if="nome_local">Local: {{ nome_local }}</div>
                                <div>Data: {{ $util.getFormatDate(this.dados_busca.referencia) }}</div>
                                <div v-if="search">Pesquisa: {{ search }}</div>
                            </div>
                        </cabecalho-generico>

                        <table class="table table-hover bg-white cabecalho-fixo" :class="detalhado ? '' : 'table-sm'">
                            <thead>
                                <tr>
                                    <th v-if="viewMode == 'P'" width="1%">
                                        <button type="button" class="btn btn-outline-primary btn-sm" @click="marcar_todos()">
                                            Todos
                                        </button>
                                    </th>
                                    <th>Descrição</th>
                                    <template v-if="tipoParm == 'P'">
                                        <th width="6%">Curva</th>
                                        <th class="text-right" width="4%" title="PR = Ponto de Ressuprimento">PR</th>
                                        <th class="text-right" width="4%" title="CMM = Consumo Médio Mensal">CMM</th>
                                        <th class="text-right" width="4%" title="EI = Estoque Ideal">EI</th>
                                        <th class="text-right" width="6%">
                                            <template v-if="id_estoque_grupo_local">Aquisição</template>
                                            <template v-else>
                                                <span title="QR = Quantidade para Ressuprimento">QR</span>
                                            </template>
                                        </th>
                                    </template>
                                    <template v-else-if="tipoParm == 'T'">
                                        <th class="text-right" width="8%">IC</th>
                                        <th class="text-right" width="8%">TMR</th>
                                    </template>
                                    <template v-else>
                                        <th class="text-right" width="10%">Preço Médio</th>
                                    </template>
                                    <th class="text-right" width="10%">Saldo</th>
                                    <th class="text-right" width="10%">Valor</th>
                                    <th class="text-right d-print-none" width="15%">Ações</th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-for="(item, itx) in lista">
                                    <tr :key="itx" :class="cor_linha(item) ? 'table-' + cor_linha(item) : ''" v-if="true">
                                        <td v-if="viewMode == 'P'">
                                            <input type="checkbox" class="form form-control" v-model="item.selec">
                                        </td>
                                        <td>
                                            <div :class="detalhado ? 'lead' : ''">
                                                {{ item.search }}
                                            </div>
                                            <template v-if="detalhado">
                                                <template v-if="item.item_parm && item.item_parm.in_estoque_ideal > 0">
                                                    <div class="progress d-print-none">
                                                        <div class="progress-bar" :class="cor_linha(item) ? 'bg-' + cor_linha(item) : ''" role="progressbar" :style="'width: ' + percentual(item.item_parm.in_estoque_ideal, item.saldo ? item.saldo.qtd : 0) + '%'"></div>
                                                    </div>
                                                </template>
                                                <div>
                                                    <span class="badge badge-secondary mr-1">
                                                        #{{ item.id_estoque_item }}
                                                    </span>
                                                    <template v-if="item.js_classes">
                                                        <a href="#" @click.prevent="search == '&quot;' + tag + '&quot;' ? search = '' : search = '&quot;' + tag + '&quot;'"
                                                                v-for="(tag, itx) in item.js_classes" :key="itx">
                                                            <span class="badge badge-secondary mr-1" >
                                                                {{ tag }}
                                                            </span>
                                                        </a>
                                                    </template>
                                                </div>
                                            </template>
                                        </td>

                                        <!-- Visualização Selecionada -->
                                        <template v-if="tipoParm == 'P'">
                                            <td title="Curva ABC">
                                                <template v-if="item.item_parm">
                                                    {{ item.item_parm.st_curva_abc }}
                                                </template>
                                            </td>
                                            <td class="text-right" title="PR = Ponto de Ressuprimento">
                                                <template v-if="item.item_parm && item.item_parm.in_ponto_ressuprimento > 0">
                                                    {{ item.item_parm.in_ponto_ressuprimento }}
                                                </template>
                                            </td>
                                            <td class="text-right" title="CMM = Consumo Médio Mensal">
                                                <template v-if="item.item_parm && item.item_parm.in_cmm > 0">
                                                    {{ item.item_parm.in_cmm }}
                                                </template>
                                            </td>
                                            <td class="text-right">
                                                <template v-if="item.item_parm && item.item_parm.in_estoque_ideal > 0">
                                                    <span title="EI = Estoque Ideal">
                                                        {{ item.item_parm.in_estoque_ideal }}
                                                    </span>
                                                </template>
                                            </td>
                                            <td class="text-right">
                                                <a href="#" @click.prevent="ver_ocs(item)" class="card-link" v-if="id_estoque_grupo_local && item.compra">
                                                    {{ item.compra.qtde }}
                                                </a>

                                                <template v-if="item.item_parm && item.item_parm.in_estoque_ideal > 0">
                                                    <div v-if="item.saldo && item.saldo.qtd < item.item_parm.in_estoque_ideal" class="small text-muted text-nowrap" title="Para ressuprir">
                                                        +{{ item.item_parm.in_estoque_ideal - ( item.saldo.qtd ? item.saldo.qtd : 0 ) }}
                                                    </div>
                                                </template>
                                            </td>
                                        </template>
                                        <template v-else-if="tipoParm == 'T'">
                                            <td class="text-right">
                                                <template v-if="item.item_parm && item.item_parm.in_intervalo_compra > 0">
                                                    {{ item.item_parm.in_intervalo_compra }}
                                                </template>
                                            </td>
                                            <td class="text-right">
                                                <template v-if="item.item_parm && item.item_parm.in_tmr > 0">
                                                    {{ item.item_parm.in_tmr }}
                                                </template>
                                            </td>
                                        </template>
                                        <template v-else>
                                            <td class="text-right">
                                                <span v-if="item.saldo && item.saldo.qtd > 0">
                                                    {{ $util.formatMoeda(item.saldo.valor / item.saldo.qtd) }}
                                                </span>
                                            </td>
                                        </template>

                                        <td class="text-right">
                                            <div>
                                                <span v-if="!item.saldo">
                                                    0
                                                </span>
                                                <span v-else>
                                                    {{ item.saldo.qtd }}
                                                </span>
                                            </div>

                                            <template v-if="detalhado">

                                                <small class="text-muted" title="Unidade de Medida">{{ item.st_unidade_estoque }}</small>

                                                <div v-if="item.grupo && item.grupo.fl_vacina && item.reservado" title="Reservado">
                                                    <a href="#" @click.prevent="ver_reservas(item)" class="card-link">
                                                        <small>Reservado: {{ item.reservado }}</small>
                                                    </a>
                                                </div>

                                            </template>
                                        </td>
                                        <td class="text-right">
                                            <div>
                                                <span v-if="item.saldo">
                                                    {{ $util.formatMoeda(item.saldo.valor) }}
                                                </span>
                                            </div>
                                        </td>
                                        <td class="text-right d-print-none text-nowrap">
                                            <button type="button" class="btn ml-1" :class="detalhado ? 'btn-outline-primary' : 'btn-link py-0 px-1'" data-toggle="tooltip" data-placement="top" title="Informações do Item." @click="exibir_info(item)">
                                                <i class="fas fa-info-circle"></i>
                                            </button>
                                            <button type="button" class="btn ml-1" :class="detalhado ? 'btn-outline-primary' : 'btn-link py-0 px-1'" data-toggle="tooltip" data-placement="top" title="Movimentações." @click="abrir_saldo(item)">
                                                <i class="fa-solid fa-dolly"></i>
                                            </button>
                                            <button type="button" class="btn ml-1" :class="detalhado ? 'btn-outline-primary' : 'btn-link py-0 px-1'" data-toggle="tooltip" data-placement="top" title="Saldos por Local de Armazenagem." @click="exibir_saldos_por_local(item)">
                                                <i class="fas fa-warehouse"></i>
                                            </button>
                                            <template v-if="id_estoque_grupo_local">
                                                <button type="button" class="btn ml-1" :class="detalhado ? 'btn-outline-secondary' : 'btn-link py-0 px-1'" data-toggle="tooltip" data-placement="top" title="Parâmetros de Estoque." @click="ver_parms(item)">
                                                    <i class="fa fa-cog" aria-hidden="true"></i>
                                                </button>
                                            </template>
                                        </td>
                                    </tr>
                                    <template v-if="buscado_por_lote && !( item.saldo_por_lote && item.saldo_por_lote.length == 1 && item.saldo_por_lote[0].st_lote == 'Sem Lote' )">
                                        <template v-for="(lote, ilx) in item.saldo_por_lote">
                                            <tr :key="'L' + itx + '-' + ilx" v-if="true">
                                                <td class="text-right">
                                                    <a href="#" @click.prevent="ver_composicao(item, lote)" v-if="!isNaN(lote.st_lote) && item.fl_kit_transform" class="mr-2">
                                                        <i class="fa-solid fa-box fa-fw" v-if="!lote.exibir_composicao"></i>
                                                        <i class="fa-solid fa-box-open fa-fw" v-else></i>
                                                    </a>
                                                    {{ $util.tratar_num_lote(lote.st_lote) }}
                                                    <div v-if="lote.consig == 'S'" class="small">
                                                        <span class="text-muted">
                                                            (Consig) 
                                                        </span>
                                                        <span v-if="lote.fornecedor">
                                                            {{ lote.fornecedor.search}}
                                                        </span>
                                                    </div>
                                                </td>
                                                <td class="text-right">
                                                    <span v-if="lote.validade">{{ $util.getFormatDate(lote.validade) }}</span>
                                                </td>
                                                <td class="text-right">{{ lote.qtd }}</td>
                                            </tr>

                                            <tr v-if="lote.exibir_composicao" :key="'L' + itx + '-' + ilx + '-C'">
                                                <td :colspan="total_colunas">
                                                    <template v-if="lote.composicao">
                                                        <composicao-item-lista :mov="lote.composicao" />
                                                    </template>
                                                    <template v-else>
                                                        Carregando...
                                                    </template>
                                                </td>
                                            </tr>
                                        </template>
                                    </template>
                                </template>
                            </tbody>
                            <!-- 
                            <template v-if="tipoParm == 'P'">
                                        <th width="6%">Curva</th>
                                        <th class="text-right" width="4%">PR</th>
                                        <th class="text-right" width="4%">CMM</th>
                                        <th class="text-right" width="4%">EI</th>
                                        <th class="text-right" width="6%">
                                            <template v-if="id_estoque_grupo_local">Aquisição</template>
                                        </th>
                                    </template>
                                    <template v-else-if="tipoParm == 'T'">
                                        <th class="text-right" width="8%">IC</th>
                                        <th class="text-right" width="8%">TMR</th>
                                    </template>
                                    <template v-else>
                                        <th class="text-right" width="10%">Preço Médio</th>
                                    </template>
                                    -->
                            <tfoot>
                                <tr>
                                    <th :colspan="2 
                                        + ( tipoParm == 'P' ? 5 : ( tipoParm == 'T' ? 2 : 1 ) ) 
                                        + ( viewMode == 'P' ? 1 : 0 )">Total</th>
                                    <th class="text-right">{{ $util.formatMoeda(totalizar(lista)) }}</th>
                                    <th class="d-print-none"></th>
                                </tr>
                                <tr v-if="viewMode == 'P' && lista_selecionado.length" class="d-print-none">
                                    <th :colspan="2 
                                        + ( tipoParm == 'P' ? 5 : ( tipoParm == 'T' ? 2 : 1 ) ) 
                                        + ( viewMode == 'P' ? 1 : 0 )">Selecionado(s)</th>
                                    <th class="text-right">
                                        {{ lista_selecionado.length }}
                                    </th>
                                    <th class="text-right">
                                        <div class="d-flex flex-column">
                                            <button type="button" class="btn btn-success mb-1" @click="incluir_aquisicao()">
                                                <i class="fas fa-search-dollar mr-2"></i>
                                                Aquisição
                                            </button>

                                            <button type="button" class="btn btn-secondary" @click="incluir_transf()" v-if="id_estoque_local">
                                                <i class="fa-solid fa-arrow-right-arrow-left mr-2"></i>
                                                Transferência
                                            </button>
                                        </div>
                                    </th>
                                </tr>
                            </tfoot>
                        </table>
                    </div>

                    <!-- FIM ITENS -->

                </div>

                <div class="tab-pane fade" id="saldo-grupos" role="tabpanel" aria-labelledby="saldo-grupos-tab">
                    <!-- GRUPOS -->

                    <div class="table-responsive-md" id="lista-saldos-grupo">

                        <cabecalho-generico titulo="Saldos por Grupo">
                            <div v-if="dados_busca">
                                <div v-if="nome_grupo_local">{{ nome_grupo_local }}</div>
                                <div v-else-if="nome_local">Local: {{ nome_local }}</div>
                                <div>Data: {{ $util.getFormatDate(this.dados_busca.referencia) }}</div>
                                <div v-if="search">Pesquisa: {{ search }}</div>
                            </div>
                        </cabecalho-generico>

                        <table class="table table-hover bg-white" :class="detalhado ? '' : 'table-sm'">
                            <thead>
                                <tr>
                                    <th>Grupo</th>
                                    <th class="text-right">Valor</th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-for="(items, grupo, igx) in grupos">
                                    <tr :key="igx" v-if="true">
                                        <td>
                                            <span v-if="grupo == 'undefined'">-</span>
                                            <a href='#' @click.prevent="filtrar_grupo(items)" v-else>
                                                {{ grupo }}
                                            </a>
                                            <span class="badge badge-secondary ml-2">
                                                {{ items.length }}
                                            </span>
                                        </td>
                                        <td class="text-right">{{ $util.formatMoeda(totalizar(items)) }}</td>
                                    </tr>
                                </template>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <th>Total</th>
                                    <th class="text-right">{{ $util.formatMoeda(totalizar(lista)) }}</th>
                                </tr>
                            </tfoot>
                        </table>

                    </div>

                    <pre v-if="false">{{ grupos }}</pre>

                    <!-- FIM GRUPOS -->
                </div>

            </div>

        </template>

        <!--
        <ul class="list-group" v-if="false">
            <li class="list-group-item d-flex justify-content-between table-hover"
                :class="item.saldo ? '' : 'list-group-item-secondary'"
                v-for="(item, itx) in lista" :key="itx">
                <div>
                    <div class="lead">
                        {{ item.search }}
                    </div>
                    <div>
                        <span class="badge badge-secondary mr-1">
                            #{{ item.id_estoque_item }}
                        </span>
                        <template v-if="item.js_classes">
                            <a href="#" @click.prevent="search == '&quot;' + tag + '&quot;' ? search = '' : search = '&quot;' + tag + '&quot;'"
                                    v-for="(tag, itx) in item.js_classes" :key="itx">
                                <span class="badge badge-secondary mr-1" >
                                    {{ tag }}
                                </span>
                            </a>
                        </template>
                    </div>
                </div>
                <div class="text-right d-flex">
                    <div class="mr-5">
                        <div>
                            <span v-if="!item.saldo">
                                0
                            </span>
                            <span v-else>
                                {{ item.saldo.qtd }}
                            </span>
                        </div>
                        <small class="text-muted">{{ item.st_unidade_estoque }}</small>
                    </div>
                    <div>
                        <button type="button" class="btn btn-outline-primary ml-1" data-toggle="tooltip" data-placement="top" title="Informações do Item." @click="exibir_info(item)">
                            <i class="fas fa-info-circle"></i>
                        </button>
                        <button type="button" class="btn btn-outline-primary ml-1" data-toggle="tooltip" data-placement="top" title="Movimentações." @click="abrir_saldo(item)">
                            <i class="fas fa-truck-loading"></i>
                        </button>
                        <button type="button" class="btn btn-outline-primary ml-1" data-toggle="tooltip" data-placement="top" title="Saldos por Local de Armazenagem." @click="exibir_saldos_por_local(item)">
                            <i class="fas fa-warehouse"></i>
                        </button>
                    </div>
                </div>
            </li>
        </ul>
        -->

        <!-- Modal -->
        <div class="modal fade" id="saldoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            {{ material ? material.search : 'Aguarde...' }}
                            <span class="badge badge-secondary ml-2" v-if="material">
                                #{{ material.id_estoque_item }}
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <az-empty-state v-if="!material" />

                        <template v-else>
                            <ul class="list-group mb-3">
                                <li class="list-group-item d-flex justify-content-between">
                                    <div>
                                        Saldo
                                        <a href="#" v-if="material.saldo" @click.prevent="emitir_etiqueta([material.saldo])" class="ml-3 text-primary fa fa-tags"></a>
                                    </div>
                                    <div class="text-right">
                                        <span>{{ material.saldo ? material.saldo.qtd : 0 }}</span>
                                        <small class="text-muted ml-1">{{ material.st_unidade_estoque }}</small>
                                        <template v-if="material.saldo">
                                            <i class="fas fa-times fa-fw mx-2"></i>
                                            <small class="text-muted mr-2">[Preço Médio]</small>
                                            <span>{{ $util.formatMoeda(material.saldo.pm) }}</span>
                                            <i class="fas fa-equals fa-fw mx-2"></i>
                                            <span>{{ $util.formatMoeda(material.saldo.valor) }}</span>
                                        </template>
                                    </div>
                                </li>
                            </ul>

                            <div class="card mt-2" v-if="material.fl_controla_lote">
                                <div class="card-header p-2 alert-info d-flex justify-content-between">
                                    <div>
                                        <a class="card-link" data-toggle="collapse" href="#solic_anteriores">
                                            Saldo por Lotes
                                        </a>

                                        <a href="#" v-if="material.saldo_por_lote" @click.prevent="emitir_etiqueta(material.saldo_por_lote)" class="ml-3 text-primary fa fa-tags"></a>
                                    </div>

                                    <div>

                                        <span class="badge badge-secondary">
                                            {{ material.saldo_por_lote ? material.saldo_por_lote.length : 0 }}
                                        </span>
                                    </div>
                                </div>
                                <div class="collapse" id="solic_anteriores">
                                    <table class="table table-sm mb-0 small" v-if="material.saldo_por_lote">
                                        <thead>
                                            <th>Lote</th>
                                            <th>Validade</th>
                                            <th class="text-right">Saldo</th>
                                            <th class="text-right">PM</th>
                                            <th class="text-right">Valor</th>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(lote, isx) in material.saldo_por_lote" :key="isx">
                                                <td>
                                                    <a href="#" @click.prevent="lote_selecionado = ( lote_selecionado == lote.st_lote ? null : lote.st_lote )" class="card-link" v-if="false">
                                                        {{ $util.tratar_num_lote(lote.st_lote) }}
                                                    </a>

                                                    <a href="#" @click.prevent="abrir_saldo(material, lote.st_lote)" class="card-link">
                                                        {{ $util.tratar_num_lote(lote.st_lote) }}
                                                    </a>

                                                    <span v-if="lote.consig == 'S'" class="ml-1 small text-muted">
                                                        (Consig) <template v-if="lote.fornecedor && lote.fornecedor.search">{{ lote.fornecedor.search }}</template>
                                                    </span>
                                                </td>
                                                <td>
                                                    {{ lote.validade ? $util.getFormatDate(lote.validade) : '' }}
                                                </td>
                                                <td class="text-right">
                                                    {{ lote.qtd }}
                                                </td>
                                                <td class="text-right">
                                                    {{ $util.formatMoeda(lote.pm, 6) }}
                                                </td>
                                                <td class="text-right">
                                                    {{ $util.formatMoeda(lote.valor) }}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <p v-if="lote_selecionado" class="alert alert-secondary">
                                Lote: {{ lote_selecionado }}
                                <button type="button" class="close" @click="abrir_saldo(material, false)">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </p>
                        </template>

                        <ficha-de-estoque ref="ficha" v-show="material" :lote="lote_selecionado" />

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Definir Tempo Modal -->
        <div class="modal fade" id="definirTempoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content" v-if="var_tempo">
                    <div class="modal-header">
                        <h5 class="modal-title">Definir {{ var_tempo }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <az-input
                            type="number"
                            :label="var_tempo"
                            v-model="tempo" />
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar_tempo()">Definir</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="novaAquisicaoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Gerar Processo de Aquisição</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="nova_aq">
                        <div class="form-row">
                            <div class="col col-12 col-md-8">
                                <az-input
                                    sizing="sm"
                                    label="Unidade"
                                    type="select"
                                    placeholder="Selecione..."
                                    :optionsList="$store.state.unidade.unidade_operacaos"
                                    optionsData="id_unidade_operacao"
                                    required
                                    :validate="validate"
                                    v-model="nova_aq.id_unidade_operacao">
                                </az-input>
                            </div>
                            <div class="col col-12 col-md-4">
                                <az-input
                                    sizing="sm"
                                    label="Finalização do Processo"
                                    type="date"
                                    v-model="nova_aq.dt_fim_processo" />
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col col-12">
                                <az-input
                                    sizing="sm"
                                    label="Observação"
                                    v-model="nova_aq.st_observacao" />
                            </div>
                        </div>
                        <p class="alert alert-info mt-3">
                            {{ nova_aq.items.length }} {{ nova_aq.items.length == 1 ? 'item selecionado' : 'itens selecioandos' }}
                        </p>

                        <table class="table table-sm table-hover small">
                            <thead>
                                <tr>
                                    <th>Id</th>
                                    <th>Descrição</th>
                                    <th></th>
                                    <th class="text-right">Saldo</th>
                                    <th class="text-right">EI</th>
                                    <th class="text-right">Qtde</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, iix) in nova_aq.items" :key="iix">
                                    <td>#{{ item.id_estoque_item }}</td>
                                    <td>{{ item.search }}</td>
                                    <td>{{ item.st_unidade }}</td>
                                    <td class="text-right">{{ item.in_saldo }}</td>
                                    <td class="text-right">{{ item.in_ei }}</td>
                                    <td class="text-right">{{ item.dc_quantidade }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="salvar_aquisicao()">Gerar</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal Solic Transf -->
        <div class="modal fade" id="selecTransfOrigemModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Transferência</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <az-input
                            label="Transferir de..."
                            placeholder="Selecione..."
                            type="select"
                            service="estoque_locals.index"
                            optionsData="id_estoque_local"
                            optionsMode="aql"
                            optionsName="estoque_locals.index.sup"
                            :optionsParm="{ sup: 1 }"
                            v-model="id_estoque_local_origem" />
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <button type="button" class="btn btn-success" @click="confirmar_transf()" :disabled="!id_estoque_local_origem">Solicitar</button>
                    </div>
                </div>
            </div>
        </div>

        <info-item-estoque ref="info" />
        <saldos-por-local ref="saldos_por_local" />
        <parms-item ref="parms" @refresh="refresh_parms" />
        <estoque-reservas ref="reservas" />

        <estoque-etiqueta ref="estoque_etiqueta" />

        <ver-lista-ocs ref="ver_ocs" />

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import * as moment from "moment";
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import FichaDeEstoque from './FichaDeEstoque.vue';
import InfoItemEstoque from './InfoItemEstoque.vue';
import SaldosPorLocal from './SaldosPorLocal.vue'
import PrintExport from '../../shared/PrintExport.vue';
import CabecalhoGenerico from '../../relatorios/shared/CabecalhoGenerico.vue';
import ParmsItem from './ParmsItem.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import EstoqueEtiqueta from './EstoqueEtiqueta.vue';
import EstoqueReservas from './EstoqueReservas.vue';
import VerListaOcs from './VerListaOcs.vue'
import ComposicaoItemLista from './ComposicaoItemLista.vue';

export default {
    data () {
        return {
            dados: null,
            search: "",
            referencia: this.$util.hoje(),
            viewMode: "S",
            material: null,
            id_unidade_operacao: "",
            id_estoque_local: this.$util.getCookie('estoque-armazem'),
            id_estoque_grupo_local: "",
            id_estoque_item: "", 
            lote_selecionado: null,
            firstLoad: false,
            print_id: "lista-saldos",
            dados_busca: null,
            tipoParm: 'P',
            var_tempo: null,
            tempo: "",
            tag_selecionada: "",
            id_estoque_grupo: "",
            nova_aq: null,
            validate: false,
            saldo_por_lote: false, 
            buscado_por_lote: false, 
            detalhado: true, 
            busca_consig: "", 
            id_estoque_local_origem: "", 
            curva: "", 
        }
    },

    components: {
        AzInput,
        AzEmptyState,
        FichaDeEstoque,
        InfoItemEstoque,
        SaldosPorLocal,
        PrintExport,
        CabecalhoGenerico,
        ParmsItem,
        AzSubmit,
        EstoqueEtiqueta,
        EstoqueReservas, 
        VerListaOcs, 
        ComposicaoItemLista, 
    },

    computed: {
        total_colunas: function () { 
            return 4 
                + ( this.tipoParm == 'P' ? 5 : ( this.tipoParm == 'T' ? 2 : 1 ) ) 
                + ( this.viewMode == 'P' ? 1 : 0 );
        },

        lista: function() {
            if ( !this.dados )
                return [];

            return this.dados
                .filter(item => ( this.viewMode == 'T' ) ||
                    ( this.viewMode == 'S' && item.saldo && item.saldo.qtd > 0 ) ||
                    ( this.viewMode == 'P' && item.item_parm && item.item_parm.in_ponto_ressuprimento > 0
                        && item.item_parm.in_ponto_ressuprimento >= _.get(item, 'saldo.qtd', 0) )
                )
                .filter(item => !this.curva || ( item.item_parm && item.item_parm.st_curva_abc == this.curva ) )
                .filter(item => !this.search || JSON.stringify(item).toUpperCase().indexOf(this.search.toUpperCase()) >= 0);
        },

        lista_selecionado: function () {
            return this.lista.filter(item => item.selec);
        },

        lista_tags: function () {
            if ( !this.dados )
                return [];

            return  _.orderBy(
                _.uniq(
                    this.dados.reduce((carry, item) => {
                        return item.js_classes ? carry.concat(item.js_classes) : carry;
                    }, [])
                )
            );

        },

        lista_tags_selecao: function () {
            return this.lista_tags.map(item => {
                return {
                    id: item,
                    search: item,
                };
            });
        },

        grupos: function () {
            return _.groupBy(
                _.orderBy(this.lista, 'grupo.search'),
                'grupo.search'
            );
        },

        nome_grupo_local: function () {
            if ( !this.dados_busca || !this.dados_busca.id_estoque_grupo_local || !this.$store.state.options['estoque_grupo_locals.index'] )
                return;

            const grupoLocal = this.$store.state.options['estoque_grupo_locals.index'].find(item => item.id_estoque_grupo_local == this.dados_busca.id_estoque_grupo_local)

            return grupoLocal ? grupoLocal.search : '';
        },

        nome_local: function () {
            if ( !this.dados_busca || !this.dados_busca.id_estoque_local || !this.$store.state.options['estoque_locals.index.sup'] )
                return;

            const local = this.$store.state.options['estoque_locals.index.sup'].find(item => item.id_estoque_local == this.dados_busca.id_estoque_local)

            return local ? local.search : '';
        },

        local_selecionado: function () {
            if ( !this.id_estoque_local || !this.$store.state.options['estoque_locals.index.sup'] )
                return;

            return this.$store.state.options['estoque_locals.index.sup'].find(item => item.id_estoque_local == this.id_estoque_local);
        },

        dados_saldos: function () {
            if ( !this.lista || !this.lista.length )
                return [];

            return this.lista.flatMap(item => {

                let parms = {};

                if ( item.item_parm ) {
                    parms.cmm = item.item_parm.in_cmm;
                    parms.pr = item.item_parm.in_ponto_ressuprimento;
                    parms.ei = item.item_parm.in_estoque_ideal;
                    parms.ic = item.item_parm.in_intervalo_compra;
                    parms.tmr = item.item_parm.in_tmr;
                }

                if ( this.buscado_por_lote ) { 

                    if ( item.saldo_por_lote && item.saldo_por_lote.length ) { 

                        return item.saldo_por_lote.map(lote => { 
                            return {
                                id: item.id_estoque_item,
                                descricao: item.search,
                                unidade: item.st_unidade_estoque,
                                saldo: lote.qtd,
                                valor: this.$util.formatMoeda(lote.valor),
                                pm: this.$util.formatMoeda(lote.pm),
                                lote: lote.st_lote,
                                validade: lote.validade,
                                ...parms,
                            }
                        });

                    } else { 

                        return [
                            {
                                id: item.id_estoque_item,
                                descricao: item.search,
                                unidade: item.st_unidade_estoque,
                                saldo: item.saldo ? item.saldo.qtd : 0,
                                valor: item.saldo ? this.$util.formatMoeda(item.saldo.valor) : 0,
                                pm: item.saldo ? this.$util.formatMoeda(item.saldo.pm) : 0,
                                lote: "Sem Lote", 
                                validate: "", 
                                ...parms,
                            }
                        ];


                    }

                }

                return [
                    {
                        id: item.id_estoque_item,
                        descricao: item.search,
                        unidade: item.st_unidade_estoque,
                        saldo: item.saldo ? item.saldo.qtd : 0,
                        valor: item.saldo ? this.$util.formatMoeda(item.saldo.valor) : 0,
                        pm: item.saldo ? this.$util.formatMoeda(item.saldo.pm) : 0,
                        ...parms,
                    }
                ];
            });
        },

    },

    methods: {
        get_nome_grupo_local (id_estoque_grupo_local) {
            if ( !id_estoque_grupo_local || !this.$store.state.options['estoque_grupo_locals.index'] )
                return;

            const grupoLocal = this.$store.state.options['estoque_grupo_locals.index'].find(item => item.id_estoque_grupo_local == id_estoque_grupo_local)

            return grupoLocal ? grupoLocal.search : '';
        },

        get_nome_local(id_estoque_local) {
            if ( !id_estoque_local || !this.$store.state.options['estoque_locals.index.sup'] )
                return;

            const local = this.$store.state.options['estoque_locals.index.sup'].find(item => item.id_estoque_local == id_estoque_local)

            return local ? local.search : '';
        },

        //

        incluir_transf () { 
            this.id_estoque_local_origem = ""; 
            $('#selecTransfOrigemModal').modal('show');
        }, 

        confirmar_transf () {
            if ( !this.id_estoque_local_origem ) { 
                this.$toast.add({
                    severity: 'warn',
                    summary: 'Atenção',
                    detail: 'É necessário selecionar o Local de Origem para a transferência.',
                    life: 5000,
                });
                return; 
            }

            $('#selecTransfOrigemModal').modal('hide');

            let solicgeral = this.$util.get_solic_geral();

            if ( solicgeral ) { 

                solicgeral.solicitar(
                    'T', 
                    {
                        id_estoque_local: this.id_estoque_local_origem,
                        id_estoque_local_destino: this.id_estoque_local,
                        transf: true, 
                        items: this.lista_selecionado.map(item => { 
                            return { 
                                id_estoque_item: item.id_estoque_item,
                                search: item.search,
                                item: item, 
                                qtde: Math.round( 
                                    ( parseInt(_.get(item, 'item_parm.in_estoque_ideal', 0)) 
                                    - ( _.get(item, 'saldo.qtd') ? parseInt(_.get(item, 'saldo.qtd'), 0) : 0 ) ) 
                                ),
                            }
                        }),
                    },
                    () => { 
                        // this.$emit('refresh');
                    }
                );

            }

        },

        ver_composicao (item, lote) { 

            if ( lote.composicao ) { 
                lote.exibir_composicao = !lote.exibir_composicao;
                this.$forceUpdate();
                return;     
            }

            this.$util.loadItem(this, { 
                service: 'estoque_items',
                func: 'show',
                parms: { 
                    id: item.id_estoque_item,
                    composicao_lote: lote.st_lote,
                }
            })
            .then( res => {
                console.log('res', res);  
                lote.composicao = res.composicao;
                lote.exibir_composicao = !lote.exibir_composicao;
                this.$forceUpdate();
            });
            
        },

        ver_ocs (item) { 
            this.$refs.ver_ocs.abrir(item);
        }, 

        ver_reservas (item) {
            this.$refs.reservas.abrir(item);
        },

        emitir_etiqueta(items) {
            const etiquetaItens = items
                .map(lote => {
                    return {
                        checked: false,
                        id_estoque_item: lote.id_estoque_item,
                        lote: lote.st_lote,
                        validade: lote.validade,
                        qtde: lote.qtd,
                        search: this.material ? this.material.search : '',
                    }
                });

            this.$refs.estoque_etiqueta.show(etiquetaItens);
        },

        marcar_todos() {
            let selec = true;

            if ( !this.lista.find(item => !item.selec) ) {
                selec = false;
            }

            this.lista.forEach(item => {
                item.selec = selec;
            });
        },

        incluir_aquisicao(estoque_local = null) {
            this.nova_aq = null;
            this.validate = false;

            if ( this.id_estoque_local && !estoque_local ) { 
                this.$util.loadItem(this, { 
                    service: 'estoque_locals',
                    func: 'show',
                    parms: { 
                        id: this.id_estoque_local,
                    }
                })
                .then(res => { 
                    if ( res && res.id_estoque_local ) { 
                        this.incluir_aquisicao(res);
                    }
                });

                return; 
            }

            let id_unidade_operacao = ( estoque_local && estoque_local.id_unidade_operacao ) ? estoque_local.id_unidade_operacao : ""; 
            let id_estoque_grupo_local = this.id_estoque_grupo_local
                ? this.id_estoque_grupo_local
                : ( estoque_local ? estoque_local.id_estoque_grupo_local : "" );

            console.log('id_loc', this.id_estoque_local);
            console.log('local_selecionado', estoque_local);

            if ( !id_estoque_grupo_local ) { 
                this.$toast.add({
                    severity: 'warn',
                    summary: 'Atenção',
                    detail: 'É necessário selecionar um Grupo de Estoque para geração da solicitação de aquisição.',
                    life: 5000,
                });
                return; 
            }

            this.$nextTick(() => {
                this.nova_aq = {
                    id_aquisicao: null,
                    st_tipo: 'M',
                    id_unidade_operacao: id_unidade_operacao,
                    id_estoque_grupo_local: id_estoque_grupo_local,
                    dt_fim_processo: moment().add(30, 'days').format('YYYY-MM-DD'),
                    fl_ativo: true,
                    items: this.lista_selecionado.map(item => {
                        const fator = item.in_fator_conversao ? item.in_fator_conversao : 1;

                        return {
                            fl_ativo: true,
                            st_tipo: 'M',
                            id_estoque_item: item.id_estoque_item,
                            search: item.search,
                            st_unidade: ( fator > 1 && item.st_unidade_compra ) ? item.st_unidade_compra : item.st_unidade_estoque,
                            dc_quantidade: Math.round(( parseInt(_.get(item, 'item_parm.in_estoque_ideal', 0))
                                - ( _.get(item, 'saldo.qtd') ? parseInt(_.get(item, 'saldo.qtd'), 0) : 0 ) ) / fator),
                            in_fator: fator,
                            in_saldo: _.get(item, 'saldo.qtd', 0),
                            in_ei: _.get(item, 'item_parm.in_estoque_ideal', 0), 
                        };
                    }),
                    fornecedores: [],
                };

                $('#novaAquisicaoModal').modal('show');
            });
        },

        salvar_aquisicao () {
            this.$util.atualizar(this, {
                service: 'aquisicao',
                dados: this.nova_aq,
                modal: 'novaAquisicaoModal',
                toast: true,
            });
        },

        refresh_parms (parm) {
            let item = this.lista.find(ei => ei.id_estoque_item == parm.id_estoque_item);

            if ( item ) {
                item.item_parm = parm;
            }
        },

        definir_tempo (tipo) {
            this.var_tempo = tipo;
            this.tempo = "";

            $('#definirTempoModal').modal('show');
        },

        atualizar_tempo () {
            this.$util.atualizar(this, {
                service: 'estoque_item_parms',
                func: 'definir_tempo',
                dados: {
                    tipo: this.var_tempo,
                    valor: this.tempo,
                    id_estoque_grupo_local: this.id_estoque_grupo_local,
                    lista: this.lista.map(item => item.id_estoque_item),
                },
                modal: 'definirTempoModal',
                toast: true,
                reload: true,
            });
        },

        ver_parms(item) {
            this.$refs.parms.abrir(item, this.id_estoque_grupo_local);
        },

        percentual (total, parte) {
            return total > 0 ? Math.round ( ( parte / total ) * 100 ) : 0;
        },

        filtrar_grupo (items) {
            let filtro = '"' + _.get(_.first(items), 'grupo.chave') + '"'
            this.search = ( this.search == filtro ? '' : filtro );
        },

        definir_print_id () {
            this.print_id = $('#saldo-grupos').hasClass('active') ? 'lista-saldos-grupo' : 'lista-saldos';
        },

        totalizar (items) {
            return items.reduce((total, carry) => {
                const valor = _.get(carry, 'saldo.valor');
                return total + ( isNaN(valor) ? 0 : parseFloat(valor) );
            }, 0);
        },

        cor_linha (item) {
            if ( !item || !item.item_parm || !item.saldo )
                return;

            if ( item.item_parm.in_estoque_seguranca > 0 && item.item_parm.in_estoque_seguranca >= _.get(item, 'saldo.qtd', 0) )
                return 'danger';

            if ( item.item_parm.in_ponto_ressuprimento > 0 && item.item_parm.in_ponto_ressuprimento >= _.get(item, 'saldo.qtd', 0) )
                return 'warning';

            return '';
        },

        exibir_info(item) {
            $('[data-toggle="tooltip"]').tooltip('dispose');

            this.$refs.info.abrir(item.id_estoque_item);
        },

        exibir_saldos_por_local(item) {
            $('[data-toggle="tooltip"]').tooltip('dispose');

            this.$refs.saldos_por_local.abrir(item);
        },

        abrir_saldo(mat, lote = null) {
            $('[data-toggle="tooltip"]').tooltip('dispose');

            if ( lote === null ) { 
                this.lote_selecionado = null; 
                this.material = null;
            } else { 
                this.lote_selecionado = lote; 
            }

            this.$nextTick(() => {
                this.$util.load(this, {
                    service: 'estoque_items',
                    func: 'show',
                    parms: {
                        id: mat.id_estoque_item,
                        saldos: true,
                        lotes: mat.fl_controla_lote,
                        referencia: this.referencia,
                        id_estoque_local: this.id_estoque_local,
                        num_lote: this.lote_selecionado, 
                    },
                    loadTo: res => {
                        this.material = res;

                        this.$nextTick(() => { 
                            this.$refs.ficha.abrir(mat, this.id_estoque_local, this.referencia, res.saldo);        
                        });
                    }
                });

                $('#saldoModal').modal('show');
            });
        },

        load() {

            this.$util.setCookie('estoque-armazem', this.id_estoque_local);

            let nome_local = this.get_nome_local(this.id_estoque_local); 
            let nome_grupo_local = this.get_nome_grupo_local(this.id_estoque_grupo_local);

            console.log('nome_local', nome_local);
            console.log('nome_grupo_local', nome_grupo_local);

            this.dados_busca = {
                referencia: this.referencia,
                id_estoque_local: this.id_estoque_local,
                id_estoque_grupo_local: this.id_estoque_grupo_local,
                id_unidade_operacao: this.id_unidade_operacao,
                id_estoque_grupo: this.id_estoque_grupo,
                id_estoque_item: this.id_estoque_item, 
                nome_local: nome_local ? nome_local : '?',
                nome_grupo_local: nome_grupo_local ? nome_grupo_local : '?',
            };

            this.$forceUpdate(); 

            this.buscado_por_lote = this.saldo_por_lote;

            this.$util.load(this, {
                service: 'estoque_items',
                parms: {
                    saldos: true,
                    lotes: this.saldo_por_lote, 
                    ...this.dados_busca,
                    reservas: true, 
                    busca_consig: this.busca_consig
                }
            });

            this.firstLoad = true;

        }

    },

    mounted() {

        this.$store.commit("setBreadcrumb", [
            { name: "Suprimentos", path: "/suprimentos" },
            { name: "Saldos", path: "/suprimentos/saldos" }
        ]);

    },

    updated() {
        $(function () {
            $('[data-toggle="tooltip"]').tooltip();
        });
    },

}
</script>
